export default __webpack_public_path__ + "static/media/Bot-Login.9e25a4c8.jpg";